"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypographyComponent = Typography;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledTypography = _interopRequireDefault(require("./styled-typography"));
var _excluded = ["children", "dataTestId", "tag", "type"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  children: _propTypes["default"].node,
  color: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
    xxs: _propTypes["default"].string,
    xs: _propTypes["default"].string,
    s: _propTypes["default"].string,
    m: _propTypes["default"].string,
    l: _propTypes["default"].string,
    xl: _propTypes["default"].string,
    xxl: _propTypes["default"].string
  })]),
  tag: _propTypes["default"].string,
  type: _propTypes["default"].string
};
var defaultProps = {
  children: undefined,
  color: undefined,
  dataTestId: null,
  size: '7',
  tag: undefined,
  type: 'heading'
};
function Typography(_ref) {
  var children = _ref.children,
    dataTestId = _ref.dataTestId,
    tag = _ref.tag,
    type = _ref.type,
    props = _objectWithoutProperties(_ref, _excluded);
  var defaultTags = {
    display: 'h1',
    heading: 'h1',
    paragraph: 'p'
  };
  return /*#__PURE__*/_react["default"].createElement(_styledTypography["default"], _extends({
    className: "fuse-typography-element",
    "data-testid": dataTestId,
    as: tag || defaultTags[type],
    type: type
  }, props), children);
}
Typography.propTypes = propTypes;
Typography.defaultProps = defaultProps;
var _default = exports["default"] = Typography;